<template>
	<div class="main-enterprise">
		<navigations :path="path"></navigations>

		<img class="enterprise-img" src="../assets/back-5.png" alt="">

		<img class="enterprise-phone-img" src="../assets/back-1.png" alt="">

		<div class="container-enterprise">

			<div class="enterprise-hint">
				企业文化
			</div>

			<div class="enterprise-line"></div>

			<div class="enterprise-center">
				<img class="enterprise-map" src="../assets/enterprise-1.png" alt="">
			</div>

			<div class="enterprise-center-phone">
				<img class="enterprise-map" src="../assets/enterprise-phone-1.png" alt="">
			</div>

			<div class="enterprise-line"></div>

			<div class="enterprise-hint">
				时购圈-打造互联网消费生态系统 实现商消共赢
			</div>

			<div class="enterprise-text">
				<span>
					时购圈的使命是构建一个共富的生态体系。我们保护消费者和商家的权益,不断提高生态内所有参与方的收入和生活质量
				</span>
				<span>
					因为时购圈的创立不是单单的解决现代人社交和商家的问题，其实时购圈要做的是解决贫富分化问题，时购圈要解决财富集中的问题。把老百姓的钱还给老百姓。因为如此，时购圈让生活更丰富多彩让选择更自由自在,让财富在更广范围内循环,让我们紧密联系在一起。我们相信,只有让更多人富裕起来社会才能真正进步。单一的利益获取无法带来真正的提高,只有共同发展才是开创更美好未来的关键。
				</span>
			</div>

			<div class="enterprise-image">
				<img class="enterprise-image-title" src="../assets/shigouquan-title.png" alt="">
			</div>

		</div>
		<tabbar></tabbar>
	</div>

</template>

<script>
	export default {
		name: 'enterprise',
		props: {
			msg: String
		},
		data() {
			return {
				path: '/enterprise'
			}
		},
		methods: {}
	}
</script>

<style>
	html,
	body {
		width: 100%;
		height: 100%;
		margin: 0;
		overflow: auto;
	}

	.main-enterprise {
		width: 100%;
		height: 100%;
		padding-top: 100px;
		box-sizing: border-box;
	}

	.container-enterprise {
		width: 100%;
		min-height: 100%;
		padding: 5% 15% 0 15%;
		box-sizing: border-box;
	}

	.enterprise-center {
		width: 100%;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: flex-start;
		justify-content: center;
		align-items: flex-start;
		min-height: 100px;
	}

	.enterprise-line {
		width: 100%;
		height: 1px;
		background-color: rgba(0, 0, 0, 0.5);
		margin-top: 100px;
		margin-bottom: 100px;
	}

	.enterprise-map {
		width: 100%;
	}

	.enterprise-hint {
		width: 100%;
		font-weight: 900;
		letter-spacing: 5px;
		font-size: 48px;
		color: #383838;
	}

	.enterprise-img {
		width: 100%;
	}

	.enterprise-text {
		width: 100%;
		margin-top: 100px;
		margin-bottom: 100px;
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;
	}

	.enterprise-text span {
		letter-spacing: 2px;
		color: #808080;
		font-size: 16px;
		line-height: 30px;
	}

	.enterprise-image {
		width: 100%;
		height: 100px;
		box-sizing: border-box;
	}

	.enterprise-image-title {
		width: 50%;
	}

	.enterprise-phone-img {
		display: none;
	}

	.enterprise-center-phone {
		display: none;
	}

	@media screen and (max-width: 768px) {
		.enterprise-img {
			display: none;
		}

		.enterprise-phone-img {
			display: block;
			width: 100%;
		}

		.main-enterprise {
			padding-top: 70px;
		}

		.enterprise-hint {
			letter-spacing: 3px;
			font-size: 24px;
		}

		.container-enterprise {
			padding: 15% 5% 0 5%;
		}

		.enterprise-center {
			display: none;
		}

		.enterprise-line {
			display: none;
		}

		.enterprise-image-title {
			width: 100%;
		}

		.enterprise-center-phone {
			height: auto;
			display: flex;
			flex-direction: column;
			flex-wrap: nowrap;
			align-content: center;
			justify-content: center;
			align-items: center;
			margin-top: 30px;
			margin-bottom: 30px;
		}

		.enterprise-text {
			margin-top: 30px;
			margin-bottom: 30px;
		}
		
		.enterprise-text span {
			font-size: 12px;
			text-align: center;
		}

		.enterprise-image {
			height: 30px;
		}
	}
</style>